/* global axios */
import ApiClient from '../ApiClient';

class CaptainInboxes extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId } = {}) {
    return axios.get(`${this.url}/${assistantId}/inboxes`);
  }

  create(params = {}) {
    const { assistantId, inboxId, mode } = params;
    return axios.post(`${this.url}/${assistantId}/inboxes`, {
      inbox: { inbox_id: inboxId, mode },
    });
  }

  delete(params = {}) {
    const { assistantId, inboxId } = params;
    return axios.delete(`${this.url}/${assistantId}/inboxes/${inboxId}`);
  }

  // SiteUp: define o modo da IA (off/suggest_manual/suggest_auto/autonomous)
  // desta caixa para o assistente.
  updateMode(params = {}) {
    const { assistantId, inboxId, mode } = params;
    return axios.patch(`${this.url}/${assistantId}/inboxes/${inboxId}`, {
      inbox: { mode },
    });
  }

  // SiteUp (SITE-7): salva o horário de atuação da IA desta caixa
  // (24h/inside/outside + schedule por dia + fuso) — independe do expediente.
  updateAiHours(params = {}) {
    const { assistantId, inboxId, aiHours } = params;
    return axios.patch(
      `${this.url}/${assistantId}/inboxes/${inboxId}/ai_hours`,
      { inbox: aiHours }
    );
  }
}

export default new CaptainInboxes();
